
    <div class="invite-container">
      <h1>Invite Your Team Members!</h1>
      <p>
        Your members will be able to access the dashboard, add devices, and view notifications.
      </p>
      <button mat-button (click)="invite()">Invite Members</button>
      <a (click)="skip()">Skip</a>
    </div>
  